import userInfo from 'redux/ducks/userInfo/userInfoDucks';
import alert from 'redux/ducks/common/alertDucks';
import confirm from 'redux/ducks/common/confirmDucks';
import popup from 'redux/ducks/popup/popupDucks';
import confirmDelete from 'redux/ducks/common/confirmDeleteDucks';
import loading from 'redux/ducks/common/loadingDucks';
import serviceDesk from 'redux/ducks/serviceDesk/serviceDeskDucks';
import myPin from 'redux/ducks/setting/myPinDucks';
import integrationCategory from 'redux/ducks/setting/integrationCategoryDucks';
import changePhoto from 'redux/ducks/changePhoto/changePhotoDucks';
import findPassword from 'redux/ducks/findPassword/findPasswordDucks';
import kms from 'redux/ducks/kms/kmsDucks';
import employeeInformation from 'redux/ducks/personalInformation/employeeInformationDucks';
import passwordChange from 'redux/ducks/personalInformation/passwordChangeDucks';
import passwordHint from 'redux/ducks/personalInformation/passwordHintDucks';
import idChange from 'redux/ducks/personalInformation/idChangesDucks';
import signup from 'redux/ducks/signup/signupDucks';
import privacyPolicy from 'redux/ducks/privacyPolicy/privacyPolicyDucks';
import landing from 'redux/ducks/landing/landingDucks';
import passwordChangeForExchange from 'redux/ducks/passwordChangeForExchange/passwordChangeForExchangeDucks';
import passwordChangeForPPP from 'redux/ducks/passwordChangeForPPP/passwordChangeForPPPDucks';

export default {
  userInfo,
  alert,
  confirm,
  popup,
  confirmDelete,
  loading,
  serviceDesk,
  myPin,
  integrationCategory,
  changePhoto,
  findPassword,
  kms,
  employeeInformation,
  passwordChange,
  passwordHint,
  idChange,
  signup,
  privacyPolicy,
  landing,
  passwordChangeForExchange,
  passwordChangeForPPP,
};
